<ng-container *ngIf="!isMaskedValue; else maskedInput">
  <mat-form-field
    appearance="outline"
    [ngClass]="{ failed: !!warning || !validSnapshot }"
    (click)="readonly ? picker.open() : null"
    class="miq-form-input"
  >
    <input
      matInput
      autocomplete="no-autofill"
      [readonly]="readonly"
      [matDatepicker]="picker"
      [placeholder]="placeholder"
      [formControl]="fc"
      [required]="required"
      [min]="configuredMinDate"
      (dateChange)="onDateChange($event)"
      [avoidCopyPaste]
      [avoidActions]="avoidCopyandPasteActions"
    />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker [panelClass]="panelClass" #picker></mat-datepicker>
  </mat-form-field>
</ng-container>

<ng-template #maskedInput>
  <mat-form-field appearance="outline" [ngClass]="{ failed: !!warning || !validSnapshot }" class="miq-form-input">
    <input
      matInput
      autocomplete="new-password"
      type="password"
      disabled
      [placeholder]="placeholder"
      [value]="currentValue"
      [avoidCopyPaste]
      [avoidAllActions]="true"
    />
  </mat-form-field>
</ng-template>
